<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            事务单号：<span v-if="formData.billNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
              formData.billNo }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information"> 新增</span>
            <span v-else class="information">

              {{
                formData.stat == '0' ? '制单' : formData.stat == '1' ? '制单' : formData.stat == '2' ? '审核中' : formData.stat ==
                '5' ? '已审核' : formData.stat == '6' ? '驳回' : formData.stat == '99' ? '取消' : '取消'
              }}</span>
          </div>
          <div class="fr" v-if="workTypeName==null">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.stat == 1 || formData.stat == 6" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButton"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButton"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButton"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButton"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='配件无果二次回访申请'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonPjwg" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonPjwg"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonPjwg"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonPjwg"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonPjwg"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='服务工单二次回访申请'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonFwgd" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonFwgd"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonFwgd"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonFwgd"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonFwgd"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='申请工单驳回'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonSqgd" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonSqgd"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonSqgd"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonSqgd"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonSqgd"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='免考核申请'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonMkhsq" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonMkhsq"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonMkhsq"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonMkhsq"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonMkhsq"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='突发性特殊情况报备'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonTfx" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonTfx"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonTfx"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonTfx"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonTfx"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='配件无果二次回访申请'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonPjwg" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonPjwg"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonPjwg"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonPjwg"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonPjwg"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='服务工单二次回访申请'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonFwgd" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonFwgd"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonFwgd"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonFwgd"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonFwgd"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='申请工单驳回'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonSqgd" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonSqgd"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonSqgd"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonSqgd"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonSqgd"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='免考核申请'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonMkhsq" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonMkhsq"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonMkhsq"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonMkhsq"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonMkhsq"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
          <div class="fr" v-if="workTypeName=='突发性特殊情况报备'">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="(formData.stat == 1 || formData.stat == 6) && editButtonTfx" @click="saveData">保存</el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id != null && (formData.stat == 1) && formData.processId == null && submitButtonTfx"
                       @click="doOperate('提交', 2)">提交
            </el-button>
            <!--            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="doOperate('重新提交',2)">重新提交
            </el-button>-->
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && checkButtonTfx"
                       @click="showOrderRemaekDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id != null && formData.stat == 2 && formData.processId == null && rejectButtonTfx"
                       @click="doOperate('驳回', 6)">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && formData.processId == null && cancelButtonTfx"
                       @click="doOperate('取消', 99)">取消
            </el-button>
            <!--<el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='提交'">提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="formData.id!=null&&formData.stat==6&&formData.processId==null&&submitButton"
                       @click="showCloseDialog = true;type='重新提交'">重新提交
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&checkButton"
                       @click="showCloseDialog = true;type='审核'">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                       v-if="formData.id!=null&&formData.stat == 2&&formData.processId==null&&rejectButton"
                       @click="showCloseDialog = true;type='驳回'">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close"
                       v-if="formData.id!=null&&formData.stat == 1&&formData.processId==null&&cancelButton"
                       @click="showCloseDialog = true;type='取消'">取消
            </el-button>-->
          </div>
        </div>
        <div>
          <!-- 基本信息 -->
          <dix style="overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important;display: block ">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>主信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>

                      事务单号
                    </th>
                    <td><el-input type="text" autocomplete="off" v-model="formData.billNo" disabled clearable /></td>
                    <th>
                      <em class="f-red">*</em>

                      单据状态
                    </th>
                    <td>
                      <el-select v-model="formData.stat" disabled clearable>
                        <el-option label="制单" :value="1" />
                        <el-option label="审核中" :value="2" />
                        <el-option label="已审核" :value="5" />
                        <el-option label="驳回" :value="6" />
                        <el-option label="取消" :value="99" />
                      </el-select>
                    </td>
                    <th>
                      <em class="f-red">*</em>

                      部门名称
                    </th>
                    <td v-if="this.currentSiteData === null">
                      <el-input placeholder="请选择" v-model="formData.orgName" readonly>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="assignOrg"></i>
                      </el-input>
                    </td>
                    <td v-else>
                      <el-input placeholder="请选择" v-model="formData.orgName" readonly :disabled="true">
                        <i slot="suffix" class="el-input__icon el-icon-search"></i>
                      </el-input>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      网点
                    </th>
                    <td v-if="this.currentSiteData === null">
                      <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable>
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePopFunc"></i>
                      </el-input>
                    </td>
                    <td v-else>
                      <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable :disabled="true">
                        <i slot="suffix" class="el-input__icon el-icon-search"></i>
                      </el-input>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <em class="f-red">*</em>

                        事务名称
                      </th>
                      <td>
                        <el-select v-model="workTypeModel" @change="workTypeChange" value-key="id" :disabled="workTypeDisable">
                          <el-option v-for="item in workTypes" :key="item.id" :label="item.label"
                                     :disabled="item.label == '服务工单二次回访申请' || item.label == '申请工单驳回'"
                                     v-if="formData.id || (item.label != '服务工单二次回访申请' && item.label != '申请工单驳回')"
                                     :value="item">
                          </el-option>
                        </el-select>
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        事务内容
                      </th>
                      <td colspan="5">
                        <el-input  type="textarea"
                        :autosize="{ minRows: 1, maxRows: 3}" autocomplete="off" v-model="formData.workContent" clearable />
                      </td>
                    </tr>


                  </tbody>

                </table>
                <div v-if="hostT" class="tips">

                  <div>提示：</div>
                  <div class="tips_item2">
                    <div>1、申请工单驳回的条件要求：A、发起驳回申请的工单必须是完工24小时内的工单；B、一个月只能申请4次驳回（因此只能由一级服务商账号发起申请），超过四次无法发起；C、回访驳回只能针对完工状态的，服务取消的无法操作驳回；
                    </div>
                    <div>
                      2、服务工单的二次回访的申请要求：A、该流程主要针对一般满意、不满意非常不满意的二次回访，不针对配件无果及考核工单申诉；B、发起时间必须是回访完成5天内的工单，超过时间的不予申请；C、针对此类申请会先调听之前的回访录音，如果核实录音用户表示非常清晰将不再安排二次回访。
                    </div>
                    <div>3、小批量工程报单：A、无果的三包配件可正常核销因此该流程是针对无需返厂配件（如面板单）的二次回访核销申请；B、发起时间必须是回访完成5天内的工单，超过时间的不予申请；C、根据最新服务手册要求，如果是漏创建三包配件的工单将不再给予进行旧件核销；D、如是保内录错成保外请发起特殊费用申请流程；</div>
                  </div>
                </div>
              </div>
              <div class="d-item">
                <div class="title first">
                  <b>单据列表</b>
                  <el-button type="primary" class="button-sty btn_zdy" v-if="formData.stat == 1" @click="addListRow">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
                </div>
                <vxe-table :stripe="true"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                           show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                           :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :data="formData.workLines">
                  <vxe-column type="checkbox" width="60"></vxe-column>
                  <vxe-column field="businessBillNo" title="单据号" width="180">
                    <template #default="{ row }">
                      <el-input v-model="row.businessBillNo" @blur="blurBu(row.businessBillNo)" placeholder="请输入" :disabled = "isDisabledNo">
                      </el-input>
                    </template>
                  </vxe-column>
                  <vxe-column field="businessResult" title="结果" width="280">
                    <template #default="{ row }">
                      <vxe-input v-model="row.businessResult" placeholder="请输入" disabled>
                      </vxe-input>
                    </template>
                  </vxe-column>
                  <vxe-column title="操作" width="50" v-if="formData.stat == 1">
                    <template #default="{ row, rowIndex }">
                      <div @click="handleDelete(rowIndex)">
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>附件列表</b></div>
                  <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                             :action="api.uploadFileUrl" accept=".docx,.doc,.txt,.pdf,.xlsx" :show-file-list="false"
                             :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :on-progress="upVideo"
                             :headers="headers" :auto-upload="true">
                    <el-button type="primary" class="button-sty btn_zdy">
                      <i class="el-icon-plus"></i>
                      附件
                    </el-button>
                  </el-upload>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                             :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                             @checkbox-all="selectChangeEvent" :data="formData.workFiles">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="fileName" title="附件名称" width="400">
                      <template #default="{ row }">
                        <!-- <a :href="row.fileUrl" :download="row.fileName">{{row.fileName}}</a> -->
                        <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>

                      </template>
                    </vxe-column>
                    <vxe-column title="操作" width="90">
                      <template #default="{ row }">
                        <div>
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i @click="deleteFile(row)" class="el-icon-delete"
                               style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>


                          <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                                      popper-class="tooltip-skin">
                            <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                                      popper-class="tooltip-skin">
                            <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                               style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>
              <!-- 流程 -->
              <wfView visible-key="showEdit" :wfData="wfData" :parent-target="_self" @reloadWf="reloadWf"></wfView>
              <div style="height:180px"></div>
            </div>
          </dix>
        </div>
      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>
    <!-- 中心弹框 -->
    <assignDialog v-if="showOrgDialog" @commitOrgSelect="commitOrgSelect" :visiable.sync="showOrgDialog" multi="true" />
    <!--网点-->
    <sitePop v-if="showSitePop" @commit="siteCommit" :visiable.sync="showSitePop" :orgId="formData.orgId" multi="true" />
    <!--操作按钮弹框 -->
    <closeDialog v-if="showCloseDialog" :dataId="formData.id" :confirmNo="formData.billNo" :type="type" @closeD="closeD"
                 :visiable.sync="showCloseDialog" multi="true" @goBackIndex="goBackIndex" />
    <!-- 审核 -->
    <orderRemark v-if="showOrderRemaekDialog" @followUpOrderRemark2="followUpOrderRemark"
                 :visiable.sync="showOrderRemaekDialog" :dataId="dataId" />

    <orderPop v-if="showOrderPop" :visiable.sync="showOrderPop" multi="false" @commit="orderCommit"
              :isWorkBill="formData.workTypeName" :siteId="formData.siteId" :rhs="true" />
    <!-- 文件预览 -->
    <Preview v-if="showPreview" @closeD="closeD2" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />

  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'
import assignDialog from "@/views/dialogCommon/orgDialog";
import { dictType, loadDictData } from "@/config/dictType";
import { mapGetters } from "vuex";
import closeDialog from "./closeDialog.vue";
import { siteMixins } from "@/mixins/tabChang";
// 流程
import wfView from "@/views/dialogCommon/wfMsgDialog.vue";
// 审核
import orderRemark from "./orderRemarkDialog";

import orderPop from './radioOrderDialog';
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],

    workTypeDisable: [String, Boolean],
    workTypeName: [String, String],

    type: String
  },
  components: {
    Preview, wfView, closeDialog, assignDialog, sitePop,
    // 审核
    orderRemark, orderPop
  },
  data() {
    return {
      addButton :false,
      editButton :false,
      exportButton :false,
      submitButton :false,
      checkButton :false,
      rejectButton :false,
      cancelButton :false,
      //配件无果
      startWfButtonPjwg :false,
      addButtonPjwg :false,
      editButtonPjwg :false,
      exportButtonPjwg :false,
      submitButtonPjwg :false,
      checkButtonPjwg :false,
      rejectButtonPjwg :false,
      cancelButtonPjwg :false,
      //服务工单
      startWfButtonFwgd :false,
      addButtonFwgd :false,
      editButtonFwgd :false,
      exportButtonFwgd :false,
      submitButtonFwgd :false,
      checkButtonFwgd :false,
      rejectButtonFwgd :false,
      cancelButtonFwgd :false,
      //申请工单驳回
      startWfButtonSqgd :false,
      addButtonSqgd :false,
      editButtonSqgd :false,
      exportButtonSqgd :false,
      submitButtonSqgd :false,
      checkButtonSqgd :false,
      rejectButtonSqgd :false,
      cancelButtonSqgd :false,
      //免考核申请
      startWfButtonMkhsq :false,
      addButtonMkhsq :false,
      editButtonMkhsq :false,
      exportButtonMkhsq :false,
      submitButtonMkhsq :false,
      checkButtonMkhsq :false,
      rejectButtonMkhsq:false,
      cancelButtonMkhsq :false,
      //突发性特殊情况
      startWfButtonTfx :false,
      addButtonTfx :false,
      editButtonTfx :false,
      exportButtonTfx :false,
      submitButtonTfx :false,
      checkButtonTfx :false,
      rejectButtonTfx :false,
      cancelButtonTfx :false,



      imgVisbleURL: '',

      showPreview: false,
      hostT: false,


      workTypeDisable: false,
      workTypeName: null,

      fileList: [],
      showOrderRemaekDialog: false,

      // 流程
      processId: '',

      wfData: {
        wfEntityId: ''
      },
      justShow: false,
      //部门/机构弹框
      showOrgDialog: false,
      //网点弹框
      showSitePop: false,
      workTypes: [],
      workTypeModel: null,
      dialogImportVisible: false,

      showCloseDialog: false,
      isCancel: false,
      selectedData: [],
      showPhotoList: [],
      formData: {
        workTypeName: null,
        stat: 1, //单据状态:1制单;2审核中;5已审核;6驳回;99取消
        workLines: [],
        workFiles: [],
        fileList: [],
        workContent: null,
        siteId: null,
      },
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      showOrderPop: false,
      isDisabledNo: false,//是否禁用工单输入框
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;

    this.submitButton = this.permissions["wkWorkBillSubmit"]; //提交
    this.checkButton = this.permissions["wkWorkBillCheck"]; //审核
    this.rejectButton = this.permissions["wkWorkBillReject"]; //驳回
    this.cancelButton = this.permissions["wkWorkBillCancel"]; //取消

    //配件无果
    this.startWfButtonPjwg = this.permissions["wkWorkBillStartWfPjwg"];
    this.addButtonPjwg = this.permissions["wkWorkBillAddPjwg"];
    this.editButtonPjwg = this.permissions["wkWorkBillEditPjwg"];
    this.exportButtonPjwg = this.permissions["wkWorkBillExportPjwg"];
    this.submitButtonPjwg= this.permissions["wkWorkBillSubmitPjwg"]; //提交
    this.checkButtonPjwg= this.permissions["wkWorkBillCheckPjwg"]; //审核
    this.rejectButtonPjwg= this.permissions["wkWorkBillRejectPjwg"]; //驳回
    this.cancelButtonPjwg= this.permissions["wkWorkBillCancelPjwg"]; //取消
    //服务工单
    this.startWfButtonFwgd = this.permissions["wkWorkBillStartWfFwgd"];
    this.addButtonFwgd = this.permissions["wkWorkBillAddFwgd"];
    this.editButtonFwgd = this.permissions["wkWorkBillEditFwgd"];
    this.exportButtonFwgd = this.permissions["wkWorkBillExportFwgd"];
    this.submitButtonFwgd = this.permissions["wkWorkBillSubmitFwgd"]; //提交
    this.checkButtonFwgd = this.permissions["wkWorkBillCheckFwgd"]; //审核
    this.rejectButtonFwgd = this.permissions["wkWorkBillRejectFwgd"]; //驳回
    this.cancelButtonFwgd = this.permissions["wkWorkBillCancelFwgd"]; //取消
    //申请工单驳回
    this.startWfButtonSqgd = this.permissions["wkWorkBillStartWfSqgd"];
    this.addButtonSqgd = this.permissions["wkWorkBillAddSqgd"];
    this.editButtonSqgd = this.permissions["wkWorkBillEditSqgd"];
    this.exportButtonSqgd = this.permissions["wkWorkBillExportSqgd"];
    this.submitButtonSqgd = this.permissions["wkWorkBillSubmitSqgd"]; //提交
    this.checkButtonSqgd = this.permissions["wkWorkBillCheckSqgd"]; //审核
    this.rejectButtonSqgd = this.permissions["wkWorkBillRejectSqgd"]; //驳回
    this.cancelButtonSqgd = this.permissions["wkWorkBillCancelSqgd"]; //取消
    //免考核申请
    this.startWfButtonMkhsq = this.permissions["wkWorkBillStartWfMkhsq"];
    this.addButtonMkhsq = this.permissions["wkWorkBillAddMkhsq"];
    this.editButtonMkhsq = this.permissions["wkWorkBillEditMkhsq"];
    this.exportButtonMkhsq = this.permissions["wkWorkBillExportMkhsq"];
    this.submitButtonMkhsq = this.permissions["wkWorkBillSubmitMkhsq"]; //提交
    this.checkButtonMkhsq = this.permissions["wkWorkBillCheckMkhsq"]; //审核
    this.rejectButtonMkhsq = this.permissions["wkWorkBillRejectMkhsq"]; //驳回
    this.cancelButtonMkhsq = this.permissions["wkWorkBillCancelMkhsq"]; //取消
    //突发性特殊情况
    this.startWfButtonTfx = this.permissions["wkWorkBillStartWfTfx"];
    this.addButtonTfx = this.permissions["wkWorkBillAddTfx"];
    this.editButtonTfx = this.permissions["wkWorkBillEditTfx"];
    this.exportButtonTfx = this.permissions["wkWorkBillExportTfx"];
    this.submitButtonTfx = this.permissions["wkWorkBillSubmitTfx"]; //提交
    this.checkButtonTfx = this.permissions["wkWorkBillCheckTfx"]; //审核
    this.rejectButtonTfx = this.permissions["wkWorkBillRejectTfx"]; //驳回
    this.cancelButtonTfx = this.permissions["wkWorkBillCancelTfx"]; //取消
  },
  mounted() {
    let host = window.location.hostname
    if (host == 'css-new-uat.vatti.com.cn' || host == 'css-new.vatti.com.cn' || host == 'css.vatti.com.cn') {
      this.hostT = true
    } else {
      this.hostT = false

    }
    this.getData()
    this.getWorkTypes()


  },
  watch: {
  },
  methods: {
    blurBu(e) {
      console.log("触发了此事件", e, this.formData.workLines);
      let newArr = [];
      for (let i = 0; i < this.formData.workLines.length - 1; i++) {
        newArr.push(this.formData.workLines[i]);
      }
      console.log(newArr, "154");

      if (newArr) {
        newArr.forEach(item => {
          if (item.businessBillNo == e) {
            this.$message.warning('单据号已存在')
            this.formData.workLines.pop()

          }
        })
      }


    },
    closeD2() {
      this.showPreview = false

    },
    // 文件下载
    handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    reloadWf() {
      console.log('保存前的刷新');
      this.$emit('editViewDataUpdate')
    },
    followUpOrderRemark() {
      console.log("刷新-------");
      this.$emit('goBackIndex')
      this.showOrderRemaekDialog = false;

    },
    //点击选择部门
    assignOrg() {
      this.showOrgDialog = true
    },
    commitOrgSelect(data) {
      this.formData.orgId = data.id;
      this.formData.orgName = data.name;
      this.formData.orgIdPath = data.orgIdPath;
    },
    //点击网点选择
    showSitePopFunc() {
      this.showSitePop = true
    },
    getWorkTypes() {
      // this.$http({
      //   url: '/admin/dict/getItemListByDictType',
      //   method: 'post',
      //   data: {
      //     dictType: 'work_type'
      //   },
      //   isLoading: true,
      //   modalStrictly: true,
      // }).then(response => {
      //   this.workTypes = response.data.data;
      // })
      loadDictData(dictType.workType).then(res => {
        this.workTypes = res.data.data

        console.log("this.workTypes", this.workTypes)
        if (this.workTypes && this.workTypes.length > 0) {
          this.workTypes.forEach(item => {
            console.log("item", item)
            if (this.workTypeName == item.label) {
              this.workTypeModel = { id: item.id, label: item.label}

              this.workTypeChange( this.workTypeModel)
            }
          })
        }

        // res.data.data.forEach(item => {
        //   this.siteQualityData.push({
        //     label: item.label,
        //     value: item.id
        //   })
        // })
      })
    },
    workTypeChange(val) {
      this.formData.workType = val.id;
      this.formData.workTypeName = val.label;
      if (this.formData.workTypeName.includes('小批量工程报单') || this.formData.workTypeName.includes('申请工单驳回') || this.formData.workTypeName.includes('服务工单二次回访申请')) {
        this.isDisabledNo = true
      }else {
        this.isDisabledNo = false;
      }
      console.log("this.formData---------", this.formData)
    },
    //新增明细
    addListRow() {
      console.log("新增明细" + this.formData.workTypeName)
      console.log("新增明细" + this.formData.workTypeName.includes('小批量工程报单'))
      if (this.formData.workTypeName.includes('小批量工程报单') || this.formData.workTypeName.includes('申请工单驳回') || this.formData.workTypeName.includes('服务工单二次回访申请')) {
        if (this.formData.workTypeName.includes('申请工单驳回')) {
          //获取驳回次数
          this.getRejectTimes()
        } else {
          if (this.formData.siteId == null) {
            this.$message.warning('请先选择网点!')
            return;
          }
          this.showOrderPop = true
        }
        this.isDisabledNo = true;
      } else {
        this.formData.workLines.push({});
        this.isDisabledNo = false;
      }
    },

    //获取驳回次数
    getRejectTimes() {
      if (this.formData.siteId == null) {
        this.$message.warning('请先选择网点!')
        return;
      }
      this.$http({
        url: api.workBill.getRejectTimes,
        method: 'post',
        data: {
          siteId: this.formData.siteId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        // if (response.data.data > 4) {
        //   this.$message.warning('一个月只能申请4次驳回(因此只能由一级服务商账号发起申请)，超过四次无法发起!')
        //   return;
        // } else {
        this.showOrderPop = true
        // }
      })
    },

    handleDelete(index) {
      this.formData.workLines.splice(index, 1);
    },
    //新增附件
    addFiles() {
      this.formData.workFiles.push({})
    },
    filesDelete(index) {
      this.formData.workFiles.splice(index, 1);
    },
    upVideo() {
      this.$mask.open()

    },
    handleFileSuccess(res, file, fileList) {
      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.formData.workFiles.push({
        fileName: fileName,
        fileUrl: url
      })
      this.$message({
        message: '附件上传成功',
        type: 'success'
      });
      this.$mask.close()
    },
    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.formData.workFiles = this.formData.workFiles.filter(item =>
          item.fileUrl !== row.fileUrl
        )
      })
    },
    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },
    // 批量删除
    handleDeleteList2() {
      if (this.area2.checkedArray.length === 0) {
        this.$message.warning('请先勾选数据')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.$http({
            url: this.deleteDataUrl,
            method: 'post',
            data: {
              deleteIdList: this.selectionRows
            }
          }).then(res => {
            this.$message.success('删除成功')
            this.reload()
          })
        })
      }
    },
    // 单个事务单据选中
    areaSelect2(data) {
      console.log(data, '选中')
      if (data.checked) {
        this.area2.checkedArray.push(data.row)
      } else {
        this.area2.checkedArray = this.area2.checkedArray.filter(item => item.id !== data.row.id)
      }
      console.log('askdfksd', this.area2.checkedArray)
    },

    // 事务单据全选
    areaSelectAll2(selection) {
      console.log(selection, "工作履历全选")
      this.area2.checkedArray = []
      let records = selection.records
      records.forEach(item => {
        this.area2.checkedArray.push(item)
      })
      console.log(this.area2.checkedArray.length)
    },

    commitSelectedRow(data) {

      this.selectedRow = data
      console.log(this.selectedRow, 'this.selectedRow传过来的值  编码');
      this.formData.itemCode = data.code
      this.formData.itemName = data.name
    },
    showPartsInvPopFunc() {

      this.showPartsInvPop = true

    },


    // 抽屉关闭
    closeD() {
      this.showAuditDialog = false
      this.showCloseDialog = false
      this.showOutboundDialog = false
    },


    deleteData() {
      let temp = this.formData.spPartsApplyLineDTOList
      this.selectedData.forEach(item => {
        temp = temp.filter(item1 => item1.selectId != item.selectId)
      })
      this.formData.spPartsApplyLineDTOList = temp
    },
    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },


    // 网点弹框选中
    siteCommit(data) {
      console.log('选中的网点', data)
      this.formData.siteId = data.id
      this.formData.siteName = data.name
      this.formData.orgId = data.orgId
      this.formData.orgName = data.orgName
      this.formData.orgIdPath = data.orgIdPath
    },
    fn2(arr) {
      const res = new Map();
      return arr.filter(arr => !res.has(arr.id) && res.set(arr.id, arr.id));
    },
    // 工单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据')
      if (this.formData.workLines.length > 0) {
        let temp=[]
        row.forEach(item=>{
          temp.push({ businessBillNo:item.orderNo,id:item.id })
        })
        console.log(temp,"fff")
        let temp2=this.formData.workLines
        let temp3=[...temp,...temp2]

        console.log(temp3,"jjj")

        let uniqueArr = this.fn2(temp3)
        console.log(uniqueArr,'kkk');
        this.formData.workLines=uniqueArr

        // let a = { businessBillNo: '' }
        // for (var i in row) {
        // a.businessBillNo = row.orderNo;
        // }
        // let temp=[]
        // 过滤删除arr2中存在的arr1数据
        // 输出：[{ c: 1 }]
        // temp=this.formData.workLines.forEach(item=>{
        // console.log(this.formData.workLines,row,"过滤前");
        // row.filter((item1,index)=>item1.id != item.id)
        // })

// console.log(temp, "temp的值");

// let temp2=[]
// temp.forEach(item3=>{
//          temp2.push({ businessBillNo:item3.orderNo,id:item3.id })

//         })
        // console.log(temp2, "temp的值2");
        // this.formData.workLines=[...this.formData.workLines,...temp2]
        //   console.log(this.formData.workLines, "this.formData.workLines的值2");



        // let isExists= false
        // this.formData.workLines.forEach(item1 => {
        //   if (item1.businessBillNo == row.orderNo) {
        //     isExists = true
        //     this.$message.warning('单据号已存在')
        //   }
        // })
        // if(!isExists){
        //   this.formData.workLines.push({ businessBillNo: row.orderNo })
        // }

      } else {
        row.forEach(item=>{
          this.formData.workLines.push({ businessBillNo:item.orderNo,id:item.id })

        })
      }




    },

    doOperate(typeName, type) {
      this.$baseConfirm('您确定要' + typeName + '吗？').then(() => {
        this.$http({
          url: api.workBill.doOperateUrl,
          method: 'post',
          data: { id: this.formData.id, stat: type },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({ message: response.data.content, type: 'success' });
            this.reload();
          } else {
            this.$message({ message: response.data.content, type: 'warning' });
          }
        })
      })
    },
    saveData() {
      if (this.formData.siteId == null) {
        this.$message.warning('请选择网点!')
        return;
      }
      if (this.workTypeModel == null) {
        this.$message.warning('请选择事务名称')
        return
      }
      if (this.formData.workContent == null) {
        this.$message.warning('请填写事务内容')
        return
      }
      if (!this.formData.workTypeName.includes('小批量工程报单') &&
        (this.formData.workLines == null || this.formData.workLines.length === 0)) {
        this.$message.warning('请添加单据列表明细')
        return
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            if (this.formData.stat === 6) { //驳回状态重新保存的时候把状态改为制单
              this.formData.stat = 1;
            }
            this.$mask.open()

            var url = (this.isEdit ? api.workBill.updateDataUrl : api.workBill.addDataUrl);
            this.$http({
              url: url,
              method: 'post',
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message({
                type: res.data.type,
                message: res.data.content
              });
              // this.$emit('editViewDataUpdate')
              this.reload()
              this.$mask.close()

            }).catch(e => {
              this.$message.error("保存失败！");
              this.$mask.close()

            })
          });
        }
      });
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.workBill.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          this.formData = data
          this.workTypeModel = { id: data.workType }
          if (this.justShow) {
            this.showPhotoList = [data.pic1, data.pic2, data.pic3]
          }
          this.justShow = this.formData.stat != 1
          if (this.formData.workTypeName.includes('小批量工程报单') || this.formData.workTypeName.includes('申请工单驳回') || this.formData.workTypeName.includes('服务工单二次回访申请')) {
            this.isDisabledNo = true;
          }
        })
      } else { //新建
        this.enabled = true;
        if (this.currentSiteData !== null) { //网点端
          console.log("this.currentSiteData", this.currentSiteData)
          this.formData.siteName = this.currentSiteData.userName
          this.formData.siteId = this.currentSiteData.id
          this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
          this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.tips {
  width: 90%;
  margin: 10px auto;
}

.tips_item2 {
  background-color: #FDF6EC;
}
</style>
